import { render, staticRenderFns } from "./EditOrderItem.vue?vue&type=template&id=1d67d4a6&scoped=true&"
import script from "./EditOrderItem.vue?vue&type=script&lang=js&"
export * from "./EditOrderItem.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderItem.vue?vue&type=style&index=0&id=1d67d4a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d67d4a6",
  null
  
)

export default component.exports